import { render, staticRenderFns } from "./HotspotDetail.vue?vue&type=template&id=27a06f48&scoped=true"
import script from "./HotspotDetail.vue?vue&type=script&lang=js"
export * from "./HotspotDetail.vue?vue&type=script&lang=js"
import style0 from "./HotspotDetail.vue?vue&type=style&index=0&id=27a06f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a06f48",
  null
  
)

export default component.exports